import React from 'react';
import NavigationComponent from '../../commonComponents/util/NavigationComponent';
import LoadingSpinner from '../../commonComponents/util/LoadingSpinner';
import RecipientNoteModal from './NoteModal';
import RecipientSummaryPanel from './RecipientSummaryPanel';
import ConfirmationModal from '../../commonComponents/shared/ConfirmationModal';
import IncompleteApplicationWarning from '../../commonComponents/shared/IncompleteApplicationWarning';
import { formatDate, formatBankInfoDisplay,  formatCurrency } from '../../../lib/utils';
import { getRequest } from '../../../lib/apiUtils';

export default class RecipientDetailsCard extends NavigationComponent {

    constructor(props) {
        super(props);

        this.state = {
            showInactiveBankAccounts: false,
            showModals: {
                deleteNoteConfirmationModal: false,
                recipientNoteModal: false
            },
            note: {},
            downloading: false
        };
    }

    // Helper to display date as local if yyyy-mm-dd
    displayLocalDate = (dateString) => {
        if (!dateString) return '';
        if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
            const [year, month, day] = dateString.split('-').map(Number);
            return new Date(year, month - 1, day).toLocaleDateString();
        }
        return formatDate(dateString);
    };

    render() {
        const { applicantId, displayName, incomplete, taxIdNumber, teudatZahut, reportName, addressDisplay, previousAddressDisplay, email, 
                phoneNumber, secondPhoneNumber, campaignList, tags = [], orgEmployment, bankAccounts = [], notes = [], 
                references = [], solicitors = [], roshYeshivas = [], trustedPayee = {}, applicantPledges = [] } = this.props.recipient;
        const { bankRoutingNumber, bankBranchNumber, bankAccountNumber, bankAccountHolder, achRoutingNumber, achAccountNumber, achAccountType } = bankAccounts.filter(acct => acct.active)[0] || {};
        const inactiveBankAccounts = bankAccounts.filter(acct => !acct.active);
        const { disableEditMode, toggleEditMode } = this.props;

        const incompleteFields = (applicantId && incomplete) ? this.props.getIncompleteFields() : null;

        return (
            <div className="card application-details-info">
                {this.props.loading ? <LoadingSpinner height="20" /> : 
                <div>
                    <div className="flex-justify">
                        <div>
                            <p className="recipient-name">{displayName}
                                {incomplete && <span className="tag incomplete">Incomplete</span>}</p>
                            {taxIdNumber && <p className="accent-text small-text tax-id">Tax ID: {taxIdNumber}</p>}
                            {teudatZahut &&
                                <p className="accent-text small-text tax-id"> Teudat Zehut: {teudatZahut}</p>}
                        </div>
                        <div className="recipient-btns-right flex-center">
                            <div>
                                <button className="btn btn-primary primary" disabled={this.state.downloading}
                                title="Pdf Export"
                                onClick={() => {
                                    this.setState({
                                        downloading: true
                                      });
                                    getRequest(`/recipients/${applicantId}/applications/report/pdf?
                                    fields=DisplayName&
                                    fields=Amount&
                                    fields=CreationDate&
                                    fields=Reason&
                                    fields=Email&
                                    fields=DisplayAddress&
                                    fields=PhoneNumber&
                                    fields=ReportName&
                                    fields=Status&
                                    fields=References&
                                    fields=TotalPaid&
                                    fields=Currency&
                                    fields=Fund&
                                    fields=CheckOrWireDate&
                                    fields=CheckOrWireNumber&
                                    fields=ReportMemo&
                                    fields=ApplicantPledges
                                    `.replace(/ +/g, ""),
                                    null,
                                    null,
                                    { responseType: "arraybuffer" })
                                    .then(function(response) {
                                        console.log(response)
                                        let blob = new Blob([response.data], { type: 'application/pdf' })
                                        let link = document.createElement('a')
                                        link.href = window.URL.createObjectURL(blob)
                                        link.download = `${displayName}_report.pdf`
                                        link.click()
                                    })
                                    .finally(() => this.setState({
                                    downloading: false
                                  }))
                                }}>
                                    <i className="icon-printer icon-left"></i>Pdf Report</button>
                            </div>
                            {this.props.permissions.manage &&
                                <div>
                                    <button className="btn btn-accent2" disabled={disableEditMode}
                                    title={disableEditMode ? "Submit your application changes before editing recipient." : ""}
                                    onClick={toggleEditMode}>Edit</button>
                                </div>}
                        </div>
                    </div>
                    {incompleteFields &&
                        <IncompleteApplicationWarning
                            viewOnly={true}
                            fields={incompleteFields}
                        />
                    }

                    {reportName && <div>
                        <p className="small-text">
                            <span className="accent-text">Report Name: </span>
                            {reportName}
                        </p>
                        <br />
                    </div>}

                    <div className="application-details-personal-info flex-center">
                        {addressDisplay && <p className="small-text">
                            <i className="icons ion-ios-home-outline accent-text2"></i>
                            {addressDisplay}
                        </p>}
                        {previousAddressDisplay && <p className="small-text">
                            <i className="icons ion-ios-home-outline accent-text2"></i>
                            {previousAddressDisplay}
                        </p>}
                        {email && <p className="small-text">
                            <i className="icons ion-ios-email-outline accent-text2"></i>
                            {email}
                        </p>}
                        {phoneNumber && <p className="small-text">
                            <i className="icons ion-ios-telephone-outline accent-text2"></i>
                            {phoneNumber}
                        </p>}
                        {secondPhoneNumber && <p className="small-text">
                            <i className="icons ion-ios-telephone-outline accent-text2"></i>
                            {secondPhoneNumber}
                        </p>}
                        {campaignList && <p className="small-text">
                            <i className="icons ion-ios-briefcase-outline accent-text2"></i>
                            {campaignList}
                        </p>}
                        {tags.map(tag => <div key={tag.key} className="chip reverse-chip">
                            <span>{tag.value}</span>
                        </div>)}
                    </div>
                    <br />
                    {orgEmployment && <div>
                        <label className="input-label">Position:</label>
                        <div className="application-details-personal-info flex-center">
                            <p className="small-text">
                                <i className="icons ion-ios-person-outline accent-text2" />
                                {orgEmployment}
                            </p>
                        </div>
                    </div>}

                    {bankAccounts.length > 0 && <div>
                        <label className="input-label"><span className="bold-text">Account Information:</span></label>
                        <div className="application-details-account-info flex-center">
                            {bankRoutingNumber && <p className="small-text">
                                <i className="icons icon-wallet accent-text2"></i>
                                Bank Routing #: {bankRoutingNumber}
                            </p>}
                            {bankBranchNumber && <p className="small-text">
                                <i className="icons icon-pie-chart accent-text2"></i>
                                Branch #: {bankBranchNumber}
                            </p>}
                            {bankAccountNumber && <p className="small-text">
                                <i className="icons icon-calculator accent-text2"></i>
                                Account #: {bankAccountNumber}
                            </p>}
                            {bankAccountHolder && <p className="small-text">
                                <i className="material-icons accent-text2">person_outline</i>
                                Account Holder: {bankAccountHolder}
                            </p>}
                            {achRoutingNumber && <p className="small-text">
                                <i className="icons icon-wallet accent-text2"></i>
                                ACH Routing #: {achRoutingNumber}
                            </p>}
                            {achAccountNumber && <p className="small-text">
                                <i className="icons icon-calculator accent-text2"></i>
                                ACH Account #: {achAccountNumber}
                            </p>}
                            {achAccountType && <p className="small-text">
                                <i className="icons ion-ios-information-outline accent-text2" />
                                Account Type: {achAccountType}
                            </p>}

                            {inactiveBankAccounts.length > 0
                                && <span className="link-text small-text" onClick={() => this.setState({ showInactiveBankAccounts: true })}>See Inactive Accounts</span>}
                        </div>
                        <br />
                    </div>}

                    {this.state.showInactiveBankAccounts && <div className="inactive-accounts-box">
                        <i className="material-icons" onClick={() => this.setState({ showInactiveBankAccounts: false })}>close</i>
                        <table className="table">
                            <thead>
                                <tr className="table-header table-row">
                                    <th>Bank Number</th>
                                    <th>Bank Branch</th>
                                    <th>Account Number</th>
                                    <th>Account Holder</th>
                                    <th>ACH Routing #</th>
                                    <th>ACH Account #</th>
                                    <th>Account Type</th>
                                </tr>
                            </thead>
                            <tbody>
                                {inactiveBankAccounts.map(acct =>
                                    <tr key={acct.bankAccountId}>
                                        <td>{acct.bankRoutingNumber}</td>
                                        <td>{acct.bankBranchNumber}</td>
                                        <td>{acct.bankAccountNumber}</td>
                                        <td>{acct.bankAccountHolder}</td>
                                        <td>{acct.achRoutingNumber}</td>
                                        <td>{acct.achAccountNumber}</td>
                                        <td>{acct.achAccountType}</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>}

                    {references.length > 0 && <div>
                        <label className="input-label">References:</label>
                        {references.map(reference => <div key={reference.referenceId}
                            className="application-details-personal-info flex-center">
                            {reference.displayName && <p className="small-text">
                                <i className="icons ion-ios-person-outline accent-text2" />
                                {reference.displayName}
                            </p>}
                            {reference.relationship && <p className="small-text">
                                <i className="icons ion-ios-information-outline accent-text2" />
                                {reference.relationship}
                            </p>}
                            {(reference.phoneNumber || reference.secondPhoneNumber) && <p className="small-text">
                                <i className="icons ion-ios-telephone-outline accent-text2" />
                                {[reference.phoneNumber, reference.secondPhoneNumber].filter(p => p).join(' | ')}
                            </p>}
                            {reference.email && <p className="small-text">
                                <i className="icons ion-ios-email-outline accent-text2" />
                                {reference.email}
                            </p>}
                            {reference.addressDisplay && <p className="small-text">
                                <i className="icons ion-ios-location-outline accent-text2" />
                                {reference.addressDisplay}
                            </p>}
                        </div>)}
                    </div>}

                    {trustedPayee && trustedPayee.referenceId && <div>
                        <br />
                        <label className="input-label">Trusted Payee:</label>
                        <p className="small-text">{trustedPayee.displayName} - {trustedPayee.isIsraeli
                            ? formatBankInfoDisplay(trustedPayee.bankRoutingNumber, trustedPayee.bankBranchNumber, trustedPayee.bankAccountNumber, trustedPayee.bankAccountHolder)
                            : trustedPayee.addressDisplay}</p>
                    </div>}

                    {solicitors.length > 0 && <div className="mt-16">
                        <label className="input-label"><span className="bold-text">Solicitors:</span></label>
                        {solicitors.map(reference => <div key={reference.referenceId}
                            className="application-details-personal-info flex-center">
                            {reference.displayName && <p className="small-text">
                                <i className="icons ion-ios-person-outline accent-text2" />
                                {reference.displayName}
                            </p>}
                            {reference.relationship && <p className="small-text">
                                <i className="icons ion-ios-information-outline accent-text2" />
                                {reference.relationship}
                            </p>}
                            {(reference.phoneNumber || reference.secondPhoneNumber) && <p className="small-text">
                                <i className="icons ion-ios-telephone-outline accent-text2" />
                                {[reference.phoneNumber, reference.secondPhoneNumber].filter(p => p).join(' | ')}
                            </p>}
                            {reference.email && <p className="small-text">
                                <i className="icons ion-ios-email-outline accent-text2" />
                                {reference.email}
                            </p>}
                            {reference.addressDisplay && <p className="small-text">
                                <i className="icons ion-ios-location-outline accent-text2" />
                                {reference.addressDisplay}
                            </p>}
                        </div>)}
                    </div>}

                    {roshYeshivas.length > 0 && <div className="mt-16">
                        <label className="input-label"><span className="bold-text">Rosh Yeshivas:</span></label>
                        {roshYeshivas.map(reference => <div key={reference.referenceId}
                            className="application-details-personal-info flex-center">
                            {reference.displayName && <p className="small-text">
                                <i className="icons ion-ios-person-outline accent-text2" />
                                {reference.displayName}
                            </p>}
                            {reference.relationship && <p className="small-text">
                                <i className="icons ion-ios-information-outline accent-text2" />
                                {reference.relationship}
                            </p>}
                            {(reference.phoneNumber || reference.secondPhoneNumber) && <p className="small-text">
                                <i className="icons ion-ios-telephone-outline accent-text2" />
                                {[reference.phoneNumber, reference.secondPhoneNumber].filter(p => p).join(' | ')}
                            </p>}
                            {reference.email && <p className="small-text">
                                <i className="icons ion-ios-email-outline accent-text2" />
                                {reference.email}
                            </p>}
                            {reference.addressDisplay && <p className="small-text">
                                <i className="icons ion-ios-location-outline accent-text2" />
                                {reference.addressDisplay}
                            </p>}
                        </div>)}
                    </div>}

                    {applicantPledges.length > 0 && (
                        <div className="mt-16 pledges-section">
                            <label className="input-label"><span className="bold-text">Pledges:</span></label>
                            <div className="pledges-table-wrapper">
                                <table className="table pledges-table pledges-table-striped">
                                <thead>
                                    <tr className="table-header table-row">
                                        <th className="text-right">#</th>
                                        <th className="text-right">Date</th>
                                        <th className="text-right">Amount</th>
                                        <th className="text-right">Paid</th>
                                        <th className="text-right">Outstanding</th>
                                        <th className="text-left">Payout Schedule</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {applicantPledges.map((ap, index) => {
                                        const pledgeKey = ap.applicantPledgeId || `row-${index}`;
                                        const outstandingAmount = (ap.pledgeAmount || 0) - (ap.amountPaid || 0);
                                        return (
                                            <tr key={pledgeKey}>
                                                <td className="text-right" data-label="#">{ap.applicantPledgeId ? `#${ap.applicantPledgeId}` : "-"}</td>
                                                <td className="text-right" data-label="Date">{this.displayLocalDate(ap.pledgeDate)}</td>
                                                <td className="text-right" data-label="Amount">{formatCurrency(ap.pledgeAmount)}</td>
                                                <td className="text-right" data-label="Paid">{formatCurrency(ap.amountPaid)}</td>
                                                <td className="text-right" data-label="Outstanding">{formatCurrency(outstandingAmount)}</td>
                                                <td
                                                    className="pledge-schedule-cell text-left"
                                                    data-label="Payout Schedule"
                                                >
                                                    <span className="pledge-schedule-text">
                                                        {ap.payOutSchedule}
                                                    </span>
                                                    {ap.payOutSchedule && (
                                                        <span className="tooltip pledge-schedule-tooltip">
                                                            {ap.payOutSchedule}
                                                        </span>
                                                    )}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                            </div>
                        </div>
                    )}


                    <div className="details-card-section">
                        <div className="flex-justify">
                            <label className="input-label"><span className="bold-text">NOTES:</span></label>
                            {this.props.permissions.manage && <p className="xs-text link-text"
                                onClick={this.toggleModal.bind(this, "recipientNoteModal")}>Add New</p>}
                        </div>
                        <div className="details-card-rows details-card-notes">
                            {notes.map(note => <div key={note.noteId} className="details-card-note">
                                <p className="medium-text"><i className="icon-notebook accent-text2" /> {note.text}</p>
                                <p className="accent-text small-text">{note.writtenBy} on {formatDate(note.writtenOn)}</p>
                                {(note.userId === this.props.userId || this.props.isAdmin || this.props.isApprover) &&
                                    <div className="details-card-note-actions">
                                        <i className="icon-pencil primary-hover icon-right accent-text input"
                                            onClick={() => {
                                                this.setState({ note });
                                                this.toggleModal("recipientNoteModal");
                                            }}></i>
                                        <i className="icon-trash trash-hover icon-right accent-text input"
                                            onClick={() => {
                                                this.setState({ note });
                                                this.toggleModal("deleteNoteConfirmationModal");
                                            }}></i>
                                    </div>}
                            </div>)}
                        </div>
                    </div>

                    {this.props.applicationHistory.length > 1 &&
                        <div className="recipient-details-summary">
                            <RecipientSummaryPanel recipientId={applicantId} />
                        </div>}
                </div>}


                <RecipientNoteModal
                    show={this.state.showModals.recipientNoteModal}
                    close={() => {
                        this.setState({ note: {} });
                        this.toggleModal("recipientNoteModal")
                    }}
                    note={this.state.note}
                    save={text => this.state.note.noteId ? this.props.updateNote(applicantId, this.state.note.noteId, text) : this.props.addNote(applicantId, text)}
                    loading={this.props.updatingNote.loading}
                    success={this.props.updatingNote.success} />

                <ConfirmationModal
                    show={this.state.showModals.deleteNoteConfirmationModal}
                    close={() => {
                        this.setState({ note: {} });
                        this.toggleModal('deleteNoteConfirmationModal')
                    }}
                    message='Are you sure you want to permanently delete this note?'
                    confirm={this.props.deleteNote.bind(this, applicantId, this.state.note.noteId)}
                    loading={this.props.updatingNote.loading}
                    success={this.props.updatingNote.success} />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/recipientAccountsComponents/recipientAccountDetails/RecipientDetailsCard.jsx